import gql from 'graphql-tag'

import { PortalError, PortalErrorType } from '../../../../domain'

import { buildMutationHandler, MutationHandler } from './Builders'
import { TypedResponse } from './Response'

const BULK_DELETE_CONNECTWARE_LICENSES = gql`
    mutation BulkDeleteConnectwareLicenses($ids: [ID]!) {
        bulkDeleteConnectwareLicenses(ids: $ids) {
            success
            message
        }
    }
`

interface DeleteInput {
    readonly ids: string[]
}

interface CanUserPerformOperationResponse extends TypedResponse<'CanUserPerformOperationResponse'> {
    readonly success: boolean
    readonly message: string
}

export default (ids: string[]): MutationHandler<DeleteInput, { readonly bulkDeleteConnectwareLicenses: CanUserPerformOperationResponse }, void> =>
    buildMutationHandler(
        {
            document: BULK_DELETE_CONNECTWARE_LICENSES,
            mapper: ({ data }) => {
                if (!data?.bulkDeleteConnectwareLicenses.success) {
                    throw new PortalError(PortalErrorType.SERVER_ERROR, data?.bulkDeleteConnectwareLicenses.message)
                }
            }
        },
        { ids }
    )
